export const enum THEME {
    DARK = 'dark',
    LIGHT = 'light'
};

export const enum LOCAL_STORAGE_KEY {
    THEME = 'theme'
};
